/**
 * A form pressed with gaps moves focus to the first gap, in the order
 * the boxes are drawn. The caller passes the gaps' box ids in that
 * order; the first one that exists on the page takes focus.
 */

/** Focuses the first element whose id is in `ids`, in list order.
 *  Returns whether one was found. */
export function focusFirstGap(ids: readonly string[]): boolean {
  for (const id of ids) {
    const el = document.getElementById(id);
    if (el === null) continue;
    el.focus();
    return true;
  }
  return false;
}
